import { I18n } from 'utils/i18n';

export default function agentNameConflictMessage(err) {
  if (err?.status === 409) {
    return I18n.t('AgenticChatFlow.AgentNameInUse');
  }
  return I18n.t('AgenticChatFlow.CreateAgentFailed');
}
